import type { ComponentProps, ComponentType, SVGProps } from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/shared/utils';

export const buttonSmallClassName =
  'flex h-[3.2rem] shrink-0 items-center gap-[0.4rem] pl-[0.8rem] pr-[1.2rem] rounded-[1rem] border border-stroke-bg bg-background headline5 text-primary cursor-pointer transition-colors hover:bg-secondary-bg disabled:cursor-default disabled:opacity-60';

export const buttonSmallIconClassName = 'size-[1.6rem] shrink-0';

type Props = ComponentProps<'button'> & {
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  loading?: boolean;
};

export const ButtonSmall = ({
  icon: Icon,
  loading,
  className,
  children,
  disabled,
  type = 'button',
  ...props
}: Props) => (
  <button
    type={type}
    disabled={disabled || loading}
    className={cn(buttonSmallClassName, className)}
    {...props}>
    {loading ? (
      <Loader2 className={cn(buttonSmallIconClassName, 'animate-spin')} />
    ) : (
      Icon && <Icon className={buttonSmallIconClassName} />
    )}
    {children}
  </button>
);
